// Declare the dataLayer property on the Window interface
declare global {
  interface Window {
    dataLayer: any[];
  }
}

/**
 * Универсальная функция для записи события в dataLayer
 * @param {string} eventName - Название события (например, "registration")
 * @param {Record<string, any>} eventParams - Доп. параметры события (user_id, amount и пр.)
 */
export function pushToDataLayer(
  eventName: string,
  eventParams: Record<string, any> = {},
) {
  // В dataLayer каждое событие обязательно имеет свойство 'event'
  // Остальные поля - произвольные, на ваше усмотрение
  window.dataLayer.push({
    event: eventName, // Зарезервированное имя ключа для GTM
    ...eventParams,
  });
  window.gtag("event", eventName, eventParams);
}

/**
 * Композабл для использования функции pushToDataLayer в компонентах Vue
 * @returns {Object} Объект с функцией pushToDataLayer
 */
export function usePushToDataLayer() {
  return {
    pushToDataLayer,
  };
}
